<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-toolbar>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Загрузить Тарифы</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-container fluid>
              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="12">
                  <v-file-input
                    v-model="xlsAttachment"
                    placeholder="Прикрепите файл с тарифами"
                  ></v-file-input>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-btn outlined @click="submit">Загрузить</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card>
      <v-toolbar flat>
        <v-btn icon @click="closeTariffs">
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title class="text-center colorblue"
          >Настройка тарифов банковских продуктов</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <v-btn class="ma-2" @click="loadTariffsFromXLS">
          Загрузить (xls...)
          <v-icon right>cloud_upload</v-icon>
        </v-btn>

        <v-btn class="ma-2" @click="clearTariff">
          Очистить тариф
          <v-icon right>clear</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
    </v-card>
    <v-card>
      <v-tabs-items v-model="tab" class="mt-2">
        <v-tab-item>
          <v-card-text>
            <BTTable></BTTable>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <MTTable></MTTable>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <KTTable></KTTable>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import MTTable from "./mtTable.vue";
import BTTable from "./btTable.vue";
import KTTable from "./ktTable.vue";
export default {
  components: {
    MTTable: MTTable,
    BTTable: BTTable,
    KTTable: KTTable,
  },
  data() {
    return {
      xlsAttachment: null,
      tab: 1,
      dialog: false,
      items: [
        "Базовый Тариф (БТ)",
        "Минимальный тариф (МТ)",
        "Таблица коэффициентов",
      ],
    };
  },

  methods: {
    closeTariffs() {
      this.$store.commit("SET_CURRENT_PRODUCT_IDCS", null);
      this.$router.push({ name: "calcsettings" });
    },
    clearTariff() {
      const formData = new FormData();
      formData.append("productID", this.$store.getters.getCurrentProductIDCS);
      this.$store.dispatch("clearTariffsAndGetNewDataCS", formData).then(() => {
        this.$store.dispatch("RefreshProductsCS").then(() => {});
      });
    },

    submit() {
      const formData = new FormData();
      formData.append("productID", this.$store.getters.getCurrentProductIDCS);
      formData.append("attachment", this.xlsAttachment);
      this.$store.dispatch("loadTariffsCS", formData).then(() => {
        this.dialog = false;
        this.$store.dispatch("RefreshProductsCS").then(() => {});
      });
    },
    onAttachmentChange(e) {
      this.attachment = e.target.files[0];
    },
    loadTariffsFromXLS() {
      this.dialog = true;
    },
  },
  mounted() {
    this.setTitle(`Загрузить Тарифы`);
  },
  //getCalculatorSettingsSimple
};
</script>

<style lang="scss">
.custom-file-input {
  opacity: 1;
}
</style>
